export default __webpack_public_path__ + "static/media/sugarfree.86070452.png";